"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-a1f5db3c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "import-text" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1 /* HOISTED */));
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "import-box-text" }, "ファイルをインポート", -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        "xml:space": "preserve",
        viewBox: "0 0 85 85",
        id: "upload-icon",
        width: "100px"
    }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("path", {
            fill: "#52a3d5",
            d: "M71.1,29.6c0-0.3,0-0.6,0-0.9c0-7.5-6.1-13.5-13.5-13.5c-3,0-5.8,1-8.2,2.8C47,11.8,40.9,7.5,34.2,7.5\n              c-9,0-16.2,7.3-16.2,16.3c0,1.8,0,4.2-0.1,5.4c-9,0.5-16.6,7.9-16.6,16.3c0,5.9,3.2,11.4,8.4,14.2c0.2,0.1,0.3,0.1,0.5,0.1h11\n              c0,0.1,0,0.2,0,0.3c0,12.1,9.9,22,22,22c12.1,0,22-9.9,22-22c0-0.1,0-0.2,0-0.3h10.1c0.2,0,0.4,0,0.5-0.1c5.2-2.9,8.4-8.3,8.4-14.2\n              C84.1,37.8,78.6,31.1,71.1,29.6z M43.1,80.1c-11,0-19.9-8.9-19.9-19.9c0-11,8.9-19.9,19.9-19.9c11,0,19.9,8.9,19.9,19.9\n              C63,71.1,54.1,80.1,43.1,80.1z M74.9,57.8H65c-1.2-11-10.6-19.6-21.9-19.6c-11.3,0-20.7,8.6-21.9,19.6H10.4\n              c-4.4-2.5-7.1-7.2-7.1-12.3c0-7.5,7.3-14.2,15.5-14.2c1.1,0,1.1-0.5,1.1-3.3c0-1.3,0-2.9,0-4.2c0-7.8,6.3-14.2,14.1-14.2\n              c6.3,0,12,4.3,13.7,10.4c0.1,0.4,0.4,0.6,0.7,0.7c0.4,0.1,0.8,0,1-0.3c2.2-2.1,5-3.2,8-3.2c6.3,0,11.4,5.1,11.4,11.4\n              c0,0.6,0,1.1-0.1,1.5c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.4,0.4,0.7,0.4c7,0.9,12.2,6.9,12.2,14C82,50.5,79.3,55.2,74.9,57.8z\n              M49.1,57.1c-0.4,0.4-1.1,0.5-1.5,0.1l-3.4-3v15.7c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1V54.2l-3.4,3\n              c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.8-0.4c-0.4-0.4-0.3-1.1,0.1-1.5l5.2-4.6c0.4-0.3,1-0.3,1.4,0l5.2,4.6\n              C49.4,56,49.5,56.7,49.1,57.1z"
        })
    ])
], -1 /* HOISTED */));
const _hoisted_7 = { class: "current-file-name" };
const _hoisted_8 = {
    class: "csv-file-label",
    for: "staff-csv-file"
};
const _hoisted_9 = { class: "footer-btn-container" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const settings_js_1 = require("../js/settings.js");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ImportModal',
    props: {
        modalName: {},
        importUrl: {},
        csvName: {},
        contentText: {},
        excelDownloadLink: {},
        successCallback: {},
        errorMessage: {},
        importCsvKey: { default: "file" },
        errorCallback: {},
        sectionId: { default: "" }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const isVisible = (0, vue_3.ref)(false);
        const isImporting = (0, vue_3.ref)(false);
        const isDragging = (0, vue_3.ref)(false);
        const selectedFile = (0, vue_3.ref)(null);
        const currentFileName = (0, vue_3.computed)(() => {
            return selectedFile.value ? selectedFile.value.name : "選択されていません";
        });
        const isLoading = (0, vue_3.computed)(() => {
            return isImporting.value ? "loading" : "";
        });
        __expose({ init, openModal, closeModal });
        function init() {
            openModal();
        }
        function openModal() {
            isVisible.value = true;
        }
        function closeModal() {
            isVisible.value = false;
        }
        function onConfirm() {
            if (!isImporting.value) {
                importCsvFile();
            }
        }
        async function importCsvFile() {
            isImporting.value = true;
            if (!selectedFile.value || !isCsvFile(selectedFile.value)) {
                (0, settings_js_1.importAlertModal)().alert("CSVファイルではありません。サンプルをご確認ください。");
                isImporting.value = false;
                return;
            }
            ;
            let data = new FormData();
            data.append(props.importCsvKey, selectedFile.value);
            if (props.sectionId) {
                data.append('sectionId', props.sectionId);
            }
            try {
                const response = await fetch(props.importUrl, {
                    method: 'POST',
                    body: data,
                });
                if (!response.ok) {
                    throw response;
                }
                const result = await response.json();
                props.successCallback(result);
                isVisible.value = false;
            }
            catch (response) {
                if (props.errorCallback) {
                    const errorResponse = response;
                    const responseJSON = await errorResponse?.json?.().catch(() => undefined);
                    props.errorCallback({ status: errorResponse?.status, responseJSON });
                }
                else {
                    (0, settings_js_1.importAlertModal)().alert("CSVインポートができませんでした。");
                }
            }
            finally {
                isImporting.value = false;
            }
        }
        function isCsvFile(file) {
            let extension = file?.name.split('.').pop()?.toLowerCase();
            return extension === "csv";
        }
        function handleFileChange(event) {
            const target = event.target;
            if (!target.files?.length) {
                return;
            }
            let file = target.files[0];
            if (!file || !isCsvFile(file)) {
                (0, settings_js_1.importAlertModal)().alert("CSVファイルではありません。サンプルをご確認ください。");
                return;
            }
            ;
            selectedFile.value = file;
        }
        function handleFileDrop(event) {
            const dragEvent = event;
            isDragging.value = false;
            if (!dragEvent.dataTransfer?.files.length) {
                return;
            }
            const file = dragEvent.dataTransfer.files[0];
            if (!file) {
                return;
            }
            if (!isCsvFile(file)) {
                (0, settings_js_1.importAlertModal)().alert("CSVファイルではありません。サンプルをご確認ください。");
                return;
            }
            selectedFile.value = file;
        }
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    "modal-name": _ctx.modalName,
                    "has-title-divider": true,
                    "has-footer-divider": true,
                    onCloseModal: closeModal,
                    onConfirm: onConfirm
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" CSV" + (0, vue_2.toDisplayString)(_ctx.csvName) + "インポート ", 1 /* TEXT */)
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "import-text", {}, () => [
                                (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)(_ctx.contentText), 1 /* TEXT */)
                            ]),
                            _hoisted_3,
                            (_ctx.excelDownloadLink)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                    key: 0,
                                    referrerpolicy: "no-referrer",
                                    target: "_blank",
                                    href: _ctx.excelDownloadLink
                                }, " CSVファイルでのサンプル ", 8 /* PROPS */, _hoisted_4))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)(["import-box", { hover: isDragging.value }]),
                                id: "drop-area",
                                onDragenter: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => (isDragging.value = true), ["prevent"])),
                                onDragover: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(($event) => (isDragging.value = true), ["prevent"])),
                                onDragleave: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (isDragging.value = false), ["prevent"])),
                                onDrop: (0, vue_2.withModifiers)(handleFileDrop, ["prevent"])
                            }, [
                                _hoisted_5,
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("span", _hoisted_7, (0, vue_2.toDisplayString)(currentFileName.value), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("span", null, [
                                    (0, vue_2.createTextVNode)("ドラッグ＆ドロップまたは "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_8, [
                                        (0, vue_2.createElementVNode)("input", {
                                            type: "file",
                                            name: "file",
                                            id: "staff-csv-file",
                                            onChange: handleFileChange
                                        }, null, 32 /* NEED_HYDRATION */),
                                        (0, vue_2.createTextVNode)(" 参照 ")
                                    ])
                                ])
                            ], 34 /* CLASS, NEED_HYDRATION */)
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("button", {
                                id: "staff-import-btn",
                                class: (0, vue_2.normalizeClass)(["oplus-btn oplus-confirm-btn", isLoading.value]),
                                onClick: onConfirm
                            }, "インポート", 2 /* CLASS */)
                        ])
                    ]),
                    _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["modal-name"]))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
